import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';

import Card from '@/components/Card';
import {
  BandPanelLayout,
  ChartWrapper,
  BandPanelHeader,
  BandSectionTitle,
  BandTableContainerStack,
} from '../styles';

import { ChannelCongestionList } from '../ChannelCongestionList';
import { SpectrumChart } from '../SpectrumChart';
import { NetworksTable } from '../NetworksTable';

interface BandPanelProps {
  band: BandResult;
  bandLabel: string;
}

// Displays the band panel with congestion list, spectrum chart and networks table
export function BandPanel({ band }: BandPanelProps) {
  const { t } = useTranslation();

  return (
    <Stack gap="24px">
      <Card padding="20px">
        <BandPanelLayout>
          <ChannelCongestionList ranking={band.ranking} />
          <ChartWrapper>
            <SpectrumChart networks={band.networks} />
          </ChartWrapper>
        </BandPanelLayout>
      </Card>
      <Card padding="20px">
        <BandTableContainerStack>
          <BandPanelHeader>
            <BandSectionTitle>
              {t('scanner.networksTitle', { count: band.networks.length })}
            </BandSectionTitle>
          </BandPanelHeader>

          <NetworksTable networks={band.networks} />
        </BandTableContainerStack>
      </Card>
    </Stack>
  );
}
